<template>
	<div class="leftres">
		<div>
			<div class="inputtop">
				<template v-for="(item , index) of formdata">
					<Commondropdownlist :key="index" ref="selectinput" :options="item.options"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width"></Commondropdownlist>
				</template>
				<CommonBtngroup @select="select" :qhide="false" :show="true" @reset="reset"
					style="margin-right: 34px;margin-top: 15px;">
				</CommonBtngroup>
				<div class="relemanagebottom">
					<div class="left">
						<div style="border-bottom:  1px solid #E6E6E6;height: 48px;display: flex;align-items: center;">
							<Commonbtn v-if="qx.update" :useAutoOptional="false" :optional="deitoptional" top="216px"
								:src="require('../../assets/icon/icon-update.png')" backgroundColor="#FFF" title="修改"
								fontSize="14px" @btnclick="deit">
							</Commonbtn>
							<Commonbtn v-if="qx.submit" :optional="OKoptional" top="216px"
								:src="require('../../assets/icon/qy.png')" backgroundColor="#FFF" title="确认"
								fontSize="14px" @btnclick="OKdeit">
							</Commonbtn>
							<Commonbtn :optional="qxoptional" :src="require('../../assets/icon/qux.png')" top="216px"
								backgroundColor="#FFF" title="取消" fontSize="14px" @btnclick="cancel">
							</Commonbtn>
							<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="RoleExport"
								:src="require('@/assets/icon/daoc.png')">
							</Commonbtn>
						</div>
						<div style="width: 100%;  margin-top: 10px;background-color: #FFFFFF;">
							<Rolemanagementpermissionlisttable :total="total" :pageSize="query.pageSize"
								:tableData="tableData" @handleCurrentChange="handleCurrentChange"
								@handleSizeChange="handleSizeChange" @onRowClick="onRowClick">
							</Rolemanagementpermissionlisttable>
						</div>
					</div>
					<div class="right">
						<div
							style="border-bottom:  1px solid #E6E6E6;height: 48px;line-height: 48px; padding-left: 14px; font-size: 14px; color: #333333;font-weight: bold;">
							权限列表
						</div>
						<div style="margin: 20px;height: 80%;overflow-y: scroll;overflow-x: hidden;">
							<Treechbox @currentChecked="currentChecked" :menuIds="menuIds" ref="trees" :data="treedata">
							</Treechbox>
						</div>
						<div :class="{ 'right-s' : rightstate == false}">
						</div>
					</div>
				</div>
			</div>
			<!-- <div style="width: 980px; box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px;background-color: #FFFFFF;">
        <Departmentmanagementtable></Departmentmanagementtable>
      </div> -->
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../components/commongroup.vue'
	import Commonbtn from '../../components/common-btn.vue'
	import Rolemanagementpermissionlisttable from './components/Rolemanagementpermissionlisttable.vue'
	import Treechbox from '../../components/treelistchbox.vue'
	import treedata from './fromData/treedata.js'
	import utils from '../../common/utils'
	import {
		GetRoleUserList,
		GetMenusWithAuthorites,
		GetRoleUserAuthorities,
		SetRoleUserAuthorities,
		AuthorityListExport
	} from '@/api/home.js'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Commonbtn,
			Rolemanagementpermissionlisttable,
			Treechbox
		},
		data() {
			return {
				rightstate: false,
				treedata: [],
				deitoptional: true,
				OKoptional: true,
				qxoptional: true,
				rooboo: false,
				rid: '',
				menuIds: [],
				checkedKeys: [],
				tableData: [],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					enabled: false
				},
				formdata: [{
						inputdata: '',
						title: '所属平台',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '450px',
						options: [{
							value: '角色',
							key: ''
						}]
					},
					{
						inputdata: '',
						title: '名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '450px'
					},
				],
				total: 0,
				query: {
					pageSize: 10,
					pageIndex: 1,
					name: '',
					cCompanyId: ''
				}
			}
		},
		created() {
			this.getMenusWithAuthorites()
			this.getRoleUserList()
		},
		mounted() {
			this.treedata = JSON.parse(JSON.stringify(treedata))
			this.QX()
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				let NodeID = this.$route.query.NodeID
				data.Menus.map((item, index) => {
					if (item.NodeID == 1) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 7) {
								this.qus = items.Nodes
							}
						})
					}
				})
				this.qus.map((item, index) => {
					if (item.NodeName == 'add') {
						this.qx.add = true
					} else if (item.NodeName == 'edit') {
						this.qx.update = true
					} else if (item.NodeName == 'delete') {
						this.qx.del = true
					} else if (item.NodeName == 'stopif') {
						this.qx.del = true
					} else if (item.NodeName == 'assignment') {
						this.qx.assignment = true
					} else if (item.NodeName == 'submit') {
						this.qx.submit = true
					} else if (item.NodeName == 'enabled') {
						this.qx.enabled = true
					}
				})
			},
			// 查询
			async getRoleUserList() {
				let {
					code,
					data
				} = await GetRoleUserList(this.query);
				//console.log(code, data, data.count, " data")
				this.formdata[1].inputdata = this.query.name
				this.tableData = data.data
				this.total = data.count
			},
			// 查询树状菜单接口
			async getMenusWithAuthorites() {
				let {
					data,
					code,
				} = await GetMenusWithAuthorites({})

				if (code == 0) {
					//console.log(code, data, " data")
					this.treedata = data
					// treedata = JSON.parse(JSON.stringify(this.treedata))
				}
			},
			// 回显树状菜单
			async getRoleUserAuthorities() {
				let {
					data,
					code,
					count
				} = await GetRoleUserAuthorities({
					rid: this.rid,
					cCompanyId: this.query.cCompanyId,
				})

				if (code == 0) {
					this.menuIds = data
					this.$refs.trees._data.reftree.setCheckedKeys([])
					//console.log(this.menuIds, 'Men')
				}
			},
			// 修改接口
			async setRoleUserAuthorities() {
				let {
					message,
					code
				} = await SetRoleUserAuthorities({
					rid: this.rid,
					cCompanyId: this.query.cCompanyId,
					ids: this.checkedKeys,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '修改成功'
					});
					this.getRoleUserAuthorities()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
					this.getRoleUserAuthorities()
				}
			},
			// 导出
			async authorityListExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await AuthorityListExport(this.query);
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}-${ date.getTime() }`
					utils.downloadFile(resexprot, `用户角色权限列表导出${ str }`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			// 导出
			RoleExport() {
				this.authorityListExport()
			},
			OKdeit() {
				this.rightstate = false
				this.deitoptional = false
				this.OKoptional = true
				this.qxoptional = true
				this.setRoleUserAuthorities()
			},
			handleCurrentChange(pageindex) {
				this.query.pageIndex = pageindex
				this.getRoleUserList()
			},
			handleSizeChange(pageSize) {
				this.query.pageSize = pageSize;
				this.getRoleUserList()

			},
			// 重置
			reset() {
				this.$refs.selectinput.map((item, index) => {
					item.modelvalue = ''
				})
				this.dialogVisibles = true
			},
			cancel() {
				this.rightstate = false
				this.deitoptional = false
				this.OKoptional = true
				this.qxoptional = true
			},
			deit() {
				this.rightstate = true
				this.deitoptional = true
				this.OKoptional = false
				this.qxoptional = false
				this.checkedKeys = this.menuIds
			},
			onRowClick(val) {
				console.log(val);
				this.rooboo = true
				this.deitoptional = false
				this.rightstate = false
				this.OKoptional = true
				this.qxoptional = true
				this.rid = val.RID
				this.query.cCompanyId = val.CCompanyID
				this.getRoleUserAuthorities()
			},
			select() {
				// this.pageIndex = 1
				this.rightstate = false
				this.deitoptional = true
				this.OKoptional = true
				this.qxoptional = true
				this.$refs.trees.reftree.setCheckedKeys([])
				let e = this.$refs.selectinput
				this.query.name = e[1].modelvalue
				this.query.cCompanyId = e[0].modelvalue
				this.getRoleUserList()
			},
			currentChecked(selectpar) {
				this.checkedKeys = selectpar.checkedKeys
				console.log(this.checkedKeys)
			}

		}
	}
</script>

<style lang="less" scoped>
	.leftres {
		background: #ffffff;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
	}

	.inputtop {
		width: 980px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 60px;
	}

	.relemanagebottom {
		// border: 1px solid red;
		width: 95%;
		//height: 480px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 30px;

		.left {
			width: 605px;
			//height: 480px;
			background: #ffffff;
			box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		}

		.right {
			width: 605px;
			height: 480px;
			background: #ffffff;
			box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		}
	}

	.right-state {}

	.right-s {
		width: 605px;
		height: 480px;
		opacity: 0.5;
		background-color: #ffffff;
		cursor: no-drop;
		position: relative;
		bottom: 490px;
		z-index: 999;
	}

	/deep/.el-tree-node__content {
		width: 605px !important;
	}
</style>